<template>
  <v-container fluid>
    <h1 class="mb-5">Dokumentų žurnalas</h1>
    <v-sheet class="d-flex justify-start" color="transparent">
      <v-card flat style="width: 200px;" color="transparent" class="mr-5">
        <v-card>
          <v-list dense>
            <v-list-item-group v-model="activeTab" color="primary" mandatory>
              <v-list-item
                v-for="(item, i) in tabItems"
                :key="i"
                @click="gotoTab(item)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
      <!-- <v-card v-if="activeTab >= 0" width="100%" min-width="400px"> -->
      <v-card v-if="activeTab >= 0" width="100%" min-width="400px">
        <component :is="routeItems[activeRoute].component" class=""></component>
      </v-card>
    </v-sheet>
  </v-container>
</template>

<script>
import { authRoute } from './../../router/routeRole'
import ZurnalasGaunami from './ZurnalasGaunami'
import ZurnalasNtrGaunami from './ZurnalasNtrGaunami'
import ZurnalasSiunciami from './ZurnalasSiunciami'
import RegitraPranesimai from './RegitraPranesimai'
import TeikejasRengiamiTab from './TeikejasRengiamiTab'

export default {
  name: 'ZurnalasTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Gauti duomenys',
          route: 'zurnalasGaunami',
          component: ZurnalasGaunami,
        },
        {
          title: 'Gauti NEP duomenys',
          route: 'zurnalasNtrGaunami',
          component: ZurnalasNtrGaunami,
        },
        {
          title: 'Siųsti pranešimai',
          route: 'zurnalasSiunciami',
          component: ZurnalasSiunciami,
        },
        {
          title: 'Pranešimai apie TP',
          route: 'regitraPranesimai',
          component: RegitraPranesimai,
        },
        {
          title: 'DT rengiami',
          route: 'teikejasRengiami',
          component: TeikejasRengiamiTab,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter(item => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function(item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
